<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Add thick</title>
    <g id="Artboard" stroke="none"
       stroke-width="1" fill="none"
       fill-rule="evenodd">
      <rect id="Rectangle" fill="#004D9D"
            x="0" y="12"
            width="30" height="6"></rect>
      <rect id="Rectangle" fill="#004D9D"
            x="12" y="0"
            width="6" height="30"></rect>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
